import { Button } from "@/src/components/buttons";
import { Card } from "@/src/components/cards";
import { openDrawer } from "@/src/components/dialogs";
import { InfiniteFetchableList } from "@/src/components/fetchableLists";
import { ReferenceCategory, Reference } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { getUserId, uid } from "@/src/utils/utils";
import {  useState } from "react";
import { ReferenceForm } from "./referenceForm";

export function ReferenceChoiceList({
  current,
  allReferences,
  categories,
  onSelect,
}: {
  current: (Reference | null | undefined)[];
  categories: ReferenceCategory[];
  allReferences?: (Reference | null | undefined)[];
  onSelect: (newValue: Reference) => void;
}) {
  let [searchKey, setSearchKey] = useState("");
  const [reload, setReload] = useState(0);

  async function openReferenceDialog(reference: Reference) {
    await openDrawer({
      id: "referenceFormDrawer",
      title: "Ajouter une référence",
      content: (
        <ReferenceForm
          current={reference}
          categories={categories}
          onChange={(newValue) => {
            reference = newValue;
          }}
        />
      ),
      onConfirm: async () => {
        let result = await apiFetch("references", "addOne", {
          reference,
        });
        if (!result) return;

        onSelect(result);
        setReload(reload + 1);
      },
    });
  }

  return (
    <div>
      <InfiniteFetchableList
        queryKey={["ReferenceChoiceList", searchKey, reload]}
        getFunction={async (limit, offset, searchKey) => {
          return (
            allReferences ||
            apiFetch("references", "loadMany", {
              userId: getUserId(),
              searchKey,
              categoriesIds: categories,
              offset: offset || 0,
              limit,
              showAll: true,
            })
          );
        }}
        searchKey={searchKey}
        onSearch={(newValue) => {
          setSearchKey(newValue || "");
        }}
        emptyChild={
          searchKey && (
            <div className="center grid c1 gap10 p20">
              Aucune référence disponible
              <Button
                onClick={async () => {
                  let reference: Reference = {
                    name: `${searchKey || ""}`,
                    creator: getUserId(),
                    sections: [],
                    category: categories[0],
                  };

                  await openReferenceDialog(reference);
                }}
              >
                Créer {searchKey}
              </Button>
            </div>
          )
        }
      >
        {(items) => (
          <div className="grid c1 gap10">
            {items?.map((reference, index) => {
              if (!reference) return;
              return (
                <Card
                  key={uid()}
                  color="blue"
                  onClick={async () => {
                    onSelect(reference);
                  }}
                >
                  <div>
                    <span>{reference.name} </span>
                    {current?.find((ref) => ref?.id == reference.id) !=
                      null && <span className="main-color bold">(Ajouté)</span>}
                  </div>
                </Card>
              );
            })}
          </div>
        )}
      </InfiniteFetchableList>
    </div>
  );
}
